import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import React from 'react';
import commonStyles from '../radix-floating-elements.module.scss';

export type TooltipProps = React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Root> & {
  /** Content or element that will reveal the tooltip */
  children: React.ReactElement | React.ReactNode;
  /** Tooltip (can be complex react components or whatever you need) */
  tooltip: React.ReactNode | string;
} & Pick<TooltipPrimitive.TooltipContentProps, 'side' | 'align'>;

const Tooltip = React.forwardRef<HTMLButtonElement, TooltipProps>((props, forwardedRef) => {
  const {
    /** Content props */
    side,
    align,
    // Root props
    tooltip,
    children,
    delayDuration = 250,
    disableHoverableContent = true,
    ...rest
  } = props;

  return (
    <TooltipPrimitive.Provider disableHoverableContent={disableHoverableContent}>
      <TooltipPrimitive.Root {...rest} delayDuration={delayDuration}>
        <TooltipPrimitive.Trigger ref={forwardedRef} asChild>
          {React.isValidElement(children) ? children : <span>{children}</span>}
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            align={align}
            sideOffset={4}
            collisionPadding={4 * 4}
            className={commonStyles.tooltipContentBase}
          >
            {tooltip}
            <TooltipPrimitive.Arrow data-arrow />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
});

Tooltip.displayName = 'Tooltip';

export { Tooltip };
